import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { getYearLabel } from '../../../Common/Util/getYearLabel';
import { useConditionalityChartsDataContext } from './hooks/useConditionalityChartsDataContext';

export const ProfileCadUnicoComparisonAnual = () => {
    const { chartData } = useConditionalityChartsDataContext();

    const series = [
        {
            name: 'Cadastrados',
            data: chartData?.profileCadUnicoComparisonAnual?.map(item => item.attended)
        },
        {
            name: 'Diferença',
            data: chartData?.profileCadUnicoComparisonAnual?.map(item => item.difference)
        },
        {
            name: 'Total',
            data: chartData?.profileCadUnicoComparisonAnual?.map(item => item.total)
        }
    ];

    return (
        <SimpleBars
            title={'Comparação de Perfil CAD Unico (Anual)'}
            horizontal={false}
            subtitles={chartData?.profileCadUnicoComparisonAnual?.map((item) => getYearLabel(item.ano))}
            series={series}
            stacked
            showDataLabels={false}
        />
    );
};
